import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { formatUZS } from '@/lib/format';
import { PRODUCT_FIELD_LABELS, formatTenors, parseTenors } from '@/lib/product-schema';

interface Props {
  product: any;
  title?: string;
}

/** Butun tizim uchun yagona mahsulot ma'lumot bloki (12 kanonik maydon) */
export function ProductInfoPanel({ product, title }: Props) {
  const { t } = useTranslation();
  if (!product) {
    return (
      <div className="rounded-xl border border-border bg-muted/30 p-4 text-sm text-muted-foreground">
        {t('cat_products.notInCatalog')}
      </div>
    );
  }

  const rows: { label: string; value: React.ReactNode }[] = [
    { label: PRODUCT_FIELD_LABELS.name, value: product.name || '—' },
    { label: PRODUCT_FIELD_LABELS.sku, value: product.sku || '—' },
    { label: PRODUCT_FIELD_LABELS.brend_nomi, value: product.brend_nomi || '—' },
    { label: PRODUCT_FIELD_LABELS.atribut_nomi, value: product.atribut_nomi || '—' },
    { label: PRODUCT_FIELD_LABELS.mhik, value: product.mhik || '—' },
    { label: PRODUCT_FIELD_LABELS.mxik_nomi, value: product.mxik_nomi || '—' },
    { label: PRODUCT_FIELD_LABELS.barcode, value: product.barcode || '—' },
    { label: PRODUCT_FIELD_LABELS.category, value: product.category || '—' },
    { label: PRODUCT_FIELD_LABELS.unit, value: product.unit || '—' },
    { label: PRODUCT_FIELD_LABELS.sale_price, value: formatUZS(Number(product.sale_price) || 0) },
    { label: PRODUCT_FIELD_LABELS.allowed_tenors, value: formatTenors(parseTenors(product.allowed_tenors)) || '—' },
    {
      label: PRODUCT_FIELD_LABELS.is_murabaha_eligible,
      value: product.is_murabaha_eligible
        ? <Badge className="bg-success/10 text-success hover:bg-success/10">{t('cat_products.possible')}</Badge>
        : <Badge variant="secondary">{t('cat_common.no')}</Badge>,
    },
  ];

  return (
    <div className="rounded-xl border border-border bg-card">
      <div className="px-4 py-3 border-b border-border">
        <h3 className="text-sm font-semibold text-foreground">{title ?? t('cat_products.infoTitle')}</h3>
      </div>
      <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4 p-4">
        {rows.map(r => (
          <div key={r.label} className="min-w-0">
            <dt className="text-xs text-muted-foreground mb-1">{r.label}</dt>
            <dd className="text-sm text-foreground break-words">{r.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
